import {
  PROGRAMS_TABLE,
  GET_PROGRAMS_LIST_PENDING,
  GET_PROGRAMS_LIST_FULFILLED,
  GET_PROGRAMS_LIST_REJECTED,
  GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED,
  GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'Programs',
  tablename: PROGRAMS_TABLE,
  programs: [],
  programsassignedtologin: [],
  programsnotassignedtologin: [],
  loadingList: false,
  errors: []
}
const reducerPrograms = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROGRAMS_LIST_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_PROGRAMS_LIST_FULFILLED:
                                                            // let dataList_GET_PROGRAMS_LIST_FULFILLED = [];
                                                            // dataList_GET_PROGRAMS_LIST_FULFILLED =
                                                            //   typeof action.payload.data !== 'undefined' &&
                                                            //   action.payload.data !== null
                                                            //     ? action.payload.data.dropdowns
                                                            //     : []
      let dataList_GET_PROGRAMS_LIST_FULFILLED = [];
      if (typeof action.payload.data !== 'undefined' && action.payload.data !== null) {
        dataList_GET_PROGRAMS_LIST_FULFILLED = action.payload.data.dropdowns
      }
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        programs: dataList_GET_PROGRAMS_LIST_FULFILLED
      }
      break
    case GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED:
                                                            // dataList =
                                                            //   typeof action.payload.data !== 'undefined' &&
                                                            //   action.payload.data !== null
                                                            //     ? action.payload.data.programs
                                                            //     : []
      let dataList_GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED = [];
      if (typeof action.payload.data !== 'undefined' && action.payload.data !== null) {
        dataList_GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED = action.payload.data.programs
        dataList_GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED.splice(0,0, {id: 0, description: "Select A Program"});
      }
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        programsassignedtologin: dataList_GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST_FULFILLED
      }
      break
    case GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED:
                                                            // let dataList_GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED
                                                            // dataList_GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED =
                                                            //   typeof action.payload.data !== 'undefined' &&
                                                            //   action.payload.data !== null
                                                            //     ? action.payload.data.programs
                                                            //     : []
      let dataList_GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED = [];
      if (typeof action.payload.data !== 'undefined' && action.payload.data !== null) {
        dataList_GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED = action.payload.data.programs
        dataList_GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED.splice(0,0, {id: 0, description: "Select A Program"});
      }
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        programsnotassignedtologin: dataList_GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST_FULFILLED
      }
      break
    case GET_PROGRAMS_LIST_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    default:
      return state
  }
  return state
}
export default reducerPrograms
